// Pydantic-422 без человеческого текста — обрубаем на клиенте раньше, чем
// автор увидит непонятную ошибку. Лимит живёт рядом с мутацией, а не рядом с
// главной страницей: входов в старт генерации два (лендинг и AI-сайдбар), и
// проверка стоит в единственной точке — `useStartGeneration.start`. Экраны
// читают ту же константу только ради UI-обратной связи (гашение кнопки,
// счётчик), а не вместо неё.
export const MAX_PROMPT_LENGTH = 2000

// Счётчик показываем только на подходе к пределу — постоянно висящий в
// композере лишний, а на подходе он объясняет молчаливый отказ заранее.
export const PROMPT_LENGTH_WARN_AT = 1900

/**
 * Потолок промпта ПРАВКИ блоков (§6.1). Своя константа, а не
 * `MAX_PROMPT_LENGTH`: значения совпали случайно, это разные контракты
 * (промпт генерации курса и промпт правки), и правка одного не должна
 * молча менять другой — то же правило уже действует для `IMAGE_PROMPT_MAX`.
 */
export const BLOCK_EDIT_PROMPT_MAX = 2000
